//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const MESSAGING_API_BASE_URL = new InjectionToken<string>('MESSAGING_API_BASE_URL');

export interface IMessaginglApiService {

    /**
     * @param filter_TypeId (optional) 
     * @param filter_ActiveFrom (optional) 
     * @param filter_ActiveTo (optional) 
     * @param filter_ShowExpired (optional) 
     * @param filter_IsRead (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return Success
     */
    getMessages(filter_TypeId?: string[] | undefined, filter_ActiveFrom?: Date | undefined, filter_ActiveTo?: Date | undefined, filter_ShowExpired?: boolean | undefined, filter_IsRead?: boolean | undefined, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<MessageResultSet>;
    /**
     * @param channel (optional) 
     * @return Success
     */
    getMessageById(messageId: string, channel?: MessageChannelKind[] | undefined): Observable<Message>;
    /**
     * @return No Content
     */
    deleteMessage(messageId: string): Observable<void>;
    /**
     * @return No Content
     */
    markMessageAsRead(messageId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MessaginglApiService implements IMessaginglApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(MESSAGING_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter_TypeId (optional) 
     * @param filter_ActiveFrom (optional) 
     * @param filter_ActiveTo (optional) 
     * @param filter_ShowExpired (optional) 
     * @param filter_IsRead (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return Success
     */
    getMessages(filter_TypeId?: string[] | undefined, filter_ActiveFrom?: Date | undefined, filter_ActiveTo?: Date | undefined, filter_ShowExpired?: boolean | undefined, filter_IsRead?: boolean | undefined, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<MessageResultSet> {
        let url_ = this.baseUrl + "/api/my/messages?";
        if (filter_TypeId === null)
            throw new Error("The parameter 'filter_TypeId' cannot be null.");
        else if (filter_TypeId !== undefined)
            filter_TypeId && filter_TypeId.forEach(item => { url_ += "Filter.TypeId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ActiveFrom === null)
            throw new Error("The parameter 'filter_ActiveFrom' cannot be null.");
        else if (filter_ActiveFrom !== undefined)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo === null)
            throw new Error("The parameter 'filter_ActiveTo' cannot be null.");
        else if (filter_ActiveTo !== undefined)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_ShowExpired === null)
            throw new Error("The parameter 'filter_ShowExpired' cannot be null.");
        else if (filter_ShowExpired !== undefined)
            url_ += "Filter.ShowExpired=" + encodeURIComponent("" + filter_ShowExpired) + "&";
        if (filter_IsRead === null)
            throw new Error("The parameter 'filter_IsRead' cannot be null.");
        else if (filter_IsRead !== undefined)
            url_ += "Filter.IsRead=" + encodeURIComponent("" + filter_IsRead) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageResultSet>;
        }));
    }

    protected processGetMessages(response: HttpResponseBase): Observable<MessageResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MessageResultSet.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channel (optional) 
     * @return Success
     */
    getMessageById(messageId: string, channel?: MessageChannelKind[] | undefined): Observable<Message> {
        let url_ = this.baseUrl + "/api/my/messages/{messageId}?";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            channel && channel.forEach(item => { url_ += "channel=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMessageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processGetMessageById(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Message.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteMessage(messageId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/my/messages/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    markMessageAsRead(messageId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/my/messages/{messageId}/read";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkMessageAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkMessageAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkMessageAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


}

export class AttachmentLink implements IAttachmentLink {
    id?: string;
    permaLink?: string | undefined;
    label?: string | undefined;
    size?: number;
    readonly sizeText?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IAttachmentLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.permaLink = _data["permaLink"];
            this.label = _data["label"];
            this.size = _data["size"];
            (<any>this).sizeText = _data["sizeText"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): AttachmentLink {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["permaLink"] = this.permaLink;
        data["label"] = this.label;
        data["size"] = this.size;
        data["sizeText"] = this.sizeText;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IAttachmentLink {
    id?: string;
    permaLink?: string | undefined;
    label?: string | undefined;
    size?: number;
    sizeText?: string | undefined;
    contentType?: string | undefined;
}

export class Campaign implements ICampaign {
    id?: string;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    published?: boolean;
    activePeriod?: Period;
    isGlobal?: boolean;
    type?: MessageType;
    distributionList?: DistributionList;
    messageChannelKind?: MessageChannelKind[];
    data?: any | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: ICampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
            this.actionLink = _data["actionLink"] ? Hyperlink.fromJS(_data["actionLink"]) : <any>undefined;
            this.published = _data["published"];
            this.activePeriod = _data["activePeriod"] ? Period.fromJS(_data["activePeriod"]) : <any>undefined;
            this.isGlobal = _data["isGlobal"];
            this.type = _data["type"] ? MessageType.fromJS(_data["type"]) : <any>undefined;
            this.distributionList = _data["distributionList"] ? DistributionList.fromJS(_data["distributionList"]) : <any>undefined;
            if (Array.isArray(_data["messageChannelKind"])) {
                this.messageChannelKind = [] as any;
                for (let item of _data["messageChannelKind"])
                    this.messageChannelKind!.push(item);
            }
            this.data = _data["data"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        data["actionLink"] = this.actionLink ? this.actionLink.toJSON() : <any>undefined;
        data["published"] = this.published;
        data["activePeriod"] = this.activePeriod ? this.activePeriod.toJSON() : <any>undefined;
        data["isGlobal"] = this.isGlobal;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["distributionList"] = this.distributionList ? this.distributionList.toJSON() : <any>undefined;
        if (Array.isArray(this.messageChannelKind)) {
            data["messageChannelKind"] = [];
            for (let item of this.messageChannelKind)
                data["messageChannelKind"].push(item);
        }
        data["data"] = this.data;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICampaign {
    id?: string;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    published?: boolean;
    activePeriod?: Period;
    isGlobal?: boolean;
    type?: MessageType;
    distributionList?: DistributionList;
    messageChannelKind?: MessageChannelKind[];
    data?: any | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
}

export class CampaignDetails implements ICampaignDetails {
    id?: string;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    published?: boolean;
    activePeriod?: Period;
    isGlobal?: boolean;
    type?: MessageType;
    distributionList?: DistributionList;
    messageChannelKind?: MessageChannelKind[];
    data?: any | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    attachment?: AttachmentLink;

    constructor(data?: ICampaignDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
            this.actionLink = _data["actionLink"] ? Hyperlink.fromJS(_data["actionLink"]) : <any>undefined;
            this.published = _data["published"];
            this.activePeriod = _data["activePeriod"] ? Period.fromJS(_data["activePeriod"]) : <any>undefined;
            this.isGlobal = _data["isGlobal"];
            this.type = _data["type"] ? MessageType.fromJS(_data["type"]) : <any>undefined;
            this.distributionList = _data["distributionList"] ? DistributionList.fromJS(_data["distributionList"]) : <any>undefined;
            if (Array.isArray(_data["messageChannelKind"])) {
                this.messageChannelKind = [] as any;
                for (let item of _data["messageChannelKind"])
                    this.messageChannelKind!.push(item);
            }
            this.data = _data["data"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.attachment = _data["attachment"] ? AttachmentLink.fromJS(_data["attachment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CampaignDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        data["actionLink"] = this.actionLink ? this.actionLink.toJSON() : <any>undefined;
        data["published"] = this.published;
        data["activePeriod"] = this.activePeriod ? this.activePeriod.toJSON() : <any>undefined;
        data["isGlobal"] = this.isGlobal;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["distributionList"] = this.distributionList ? this.distributionList.toJSON() : <any>undefined;
        if (Array.isArray(this.messageChannelKind)) {
            data["messageChannelKind"] = [];
            for (let item of this.messageChannelKind)
                data["messageChannelKind"].push(item);
        }
        data["data"] = this.data;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICampaignDetails {
    id?: string;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    published?: boolean;
    activePeriod?: Period;
    isGlobal?: boolean;
    type?: MessageType;
    distributionList?: DistributionList;
    messageChannelKind?: MessageChannelKind[];
    data?: any | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    attachment?: AttachmentLink;
}

export class CampaignResultSet implements ICampaignResultSet {
    count?: number;
    items?: Campaign[] | undefined;

    constructor(data?: ICampaignResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Campaign.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CampaignResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICampaignResultSet {
    count?: number;
    items?: Campaign[] | undefined;
}

export class CampaignStatistics implements ICampaignStatistics {
    title?: string | undefined;
    readCount?: number;
    notReadCount?: number | undefined;
    deletedCount?: number;
    callToActionCount?: number;
    lastUpdated?: Date;

    constructor(data?: ICampaignStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.readCount = _data["readCount"];
            this.notReadCount = _data["notReadCount"];
            this.deletedCount = _data["deletedCount"];
            this.callToActionCount = _data["callToActionCount"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CampaignStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["readCount"] = this.readCount;
        data["notReadCount"] = this.notReadCount;
        data["deletedCount"] = this.deletedCount;
        data["callToActionCount"] = this.callToActionCount;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICampaignStatistics {
    title?: string | undefined;
    readCount?: number;
    notReadCount?: number | undefined;
    deletedCount?: number;
    callToActionCount?: number;
    lastUpdated?: Date;
}

export class Contact implements IContact {
    readonly id?: string | undefined;
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    updatedAt?: Date | undefined;
    readonly isAnonymous?: boolean;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.recipientId = _data["recipientId"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            (<any>this).isAnonymous = _data["isAnonymous"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipientId"] = this.recipientId;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isAnonymous"] = this.isAnonymous;
        return data;
    }
}

export interface IContact {
    id?: string | undefined;
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    updatedAt?: Date | undefined;
    isAnonymous?: boolean;
}

export class ContactAnonymous implements IContactAnonymous {
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IContactAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ContactAnonymous {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAnonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IContactAnonymous {
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ContactResultSet implements IContactResultSet {
    count?: number;
    items?: Contact[] | undefined;

    constructor(data?: IContactResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new ContactResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContactResultSet {
    count?: number;
    items?: Contact[] | undefined;
}

export class CreateCampaignRequest implements ICreateCampaignRequest {
    isGlobal?: boolean;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    activePeriod?: Period;
    typeId?: string | undefined;
    recipientListId?: string | undefined;
    data?: any | undefined;
    published?: boolean;
    recipientIds?: string[] | undefined;
    recipients?: ContactAnonymous[] | undefined;

    constructor(data?: ICreateCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobal = _data["isGlobal"];
            this.title = _data["title"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
            this.actionLink = _data["actionLink"] ? Hyperlink.fromJS(_data["actionLink"]) : <any>undefined;
            this.activePeriod = _data["activePeriod"] ? Period.fromJS(_data["activePeriod"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.recipientListId = _data["recipientListId"];
            this.data = _data["data"];
            this.published = _data["published"];
            if (Array.isArray(_data["recipientIds"])) {
                this.recipientIds = [] as any;
                for (let item of _data["recipientIds"])
                    this.recipientIds!.push(item);
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(ContactAnonymous.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobal"] = this.isGlobal;
        data["title"] = this.title;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        data["actionLink"] = this.actionLink ? this.actionLink.toJSON() : <any>undefined;
        data["activePeriod"] = this.activePeriod ? this.activePeriod.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["recipientListId"] = this.recipientListId;
        data["data"] = this.data;
        data["published"] = this.published;
        if (Array.isArray(this.recipientIds)) {
            data["recipientIds"] = [];
            for (let item of this.recipientIds)
                data["recipientIds"].push(item);
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCampaignRequest {
    isGlobal?: boolean;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    activePeriod?: Period;
    typeId?: string | undefined;
    recipientListId?: string | undefined;
    data?: any | undefined;
    published?: boolean;
    recipientIds?: string[] | undefined;
    recipients?: ContactAnonymous[] | undefined;
}

export class CreateContactRequest implements ICreateContactRequest {
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateContactRequest {
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateDistributionListContactRequest implements ICreateDistributionListContactRequest {
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    contactId?: string | undefined;

    constructor(data?: ICreateDistributionListContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any): CreateDistributionListContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDistributionListContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["contactId"] = this.contactId;
        return data;
    }
}

export interface ICreateDistributionListContactRequest {
    recipientId?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    contactId?: string | undefined;
}

export class CreateDistributionListRequest implements ICreateDistributionListRequest {
    name?: string | undefined;

    constructor(data?: ICreateDistributionListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDistributionListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDistributionListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDistributionListRequest {
    name?: string | undefined;
}

export class CreateMessageSenderRequest implements ICreateMessageSenderRequest {
    sender?: string | undefined;
    displayName?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ICreateMessageSenderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CreateMessageSenderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageSenderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ICreateMessageSenderRequest {
    sender?: string | undefined;
    displayName?: string | undefined;
    isDefault?: boolean;
}

export class CreateMessageTypeRequest implements ICreateMessageTypeRequest {
    name?: string | undefined;

    constructor(data?: ICreateMessageTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMessageTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMessageTypeRequest {
    name?: string | undefined;
}

export class CreateTemplateRequest implements ICreateTemplateRequest {
    name?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;

    constructor(data?: ICreateTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
        }
    }

    static fromJS(data: any): CreateTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICreateTemplateRequest {
    name?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
}

export class DistributionList implements IDistributionList {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IDistributionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DistributionList {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDistributionList {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
}

export class DistributionListResultSet implements IDistributionListResultSet {
    count?: number;
    items?: DistributionList[] | undefined;

    constructor(data?: IDistributionListResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DistributionList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistributionListResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionListResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDistributionListResultSet {
    count?: number;
    items?: DistributionList[] | undefined;
}

export class Hyperlink implements IHyperlink {
    text?: string | undefined;
    href?: string | undefined;

    constructor(data?: IHyperlink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.href = _data["href"];
        }
    }

    static fromJS(data: any): Hyperlink {
        data = typeof data === 'object' ? data : {};
        let result = new Hyperlink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["href"] = this.href;
        return data;
    }
}

export interface IHyperlink {
    text?: string | undefined;
    href?: string | undefined;
}

export class Message implements IMessage {
    id?: string;
    sender?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    isRead?: boolean;
    actionLink?: Hyperlink;
    attachmentUrl?: string | undefined;
    createdAt?: Date;
    activePeriod?: Period;
    type?: MessageType;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sender = _data["sender"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.isRead = _data["isRead"];
            this.actionLink = _data["actionLink"] ? Hyperlink.fromJS(_data["actionLink"]) : <any>undefined;
            this.attachmentUrl = _data["attachmentUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.activePeriod = _data["activePeriod"] ? Period.fromJS(_data["activePeriod"]) : <any>undefined;
            this.type = _data["type"] ? MessageType.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sender"] = this.sender;
        data["title"] = this.title;
        data["content"] = this.content;
        data["isRead"] = this.isRead;
        data["actionLink"] = this.actionLink ? this.actionLink.toJSON() : <any>undefined;
        data["attachmentUrl"] = this.attachmentUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["activePeriod"] = this.activePeriod ? this.activePeriod.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessage {
    id?: string;
    sender?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    isRead?: boolean;
    actionLink?: Hyperlink;
    attachmentUrl?: string | undefined;
    createdAt?: Date;
    activePeriod?: Period;
    type?: MessageType;
}

export class MessageContent implements IMessageContent {
    sender?: MessageSender;
    title?: string | undefined;
    body?: string | undefined;

    constructor(data?: IMessageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"] ? MessageSender.fromJS(_data["sender"]) : <any>undefined;
            this.title = _data["title"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): MessageContent {
        data = typeof data === 'object' ? data : {};
        let result = new MessageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["body"] = this.body;
        return data;
    }
}

export interface IMessageContent {
    sender?: MessageSender;
    title?: string | undefined;
    body?: string | undefined;
}

export class MessageResultSet implements IMessageResultSet {
    count?: number;
    items?: Message[] | undefined;

    constructor(data?: IMessageResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Message.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultSet {
    count?: number;
    items?: Message[] | undefined;
}

export class MessageSender implements IMessageSender {
    id?: string;
    sender?: string | undefined;
    displayName?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date | undefined;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    isDefault?: boolean;
    readonly isEmpty?: boolean;

    constructor(data?: IMessageSender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sender = _data["sender"];
            this.displayName = _data["displayName"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isDefault = _data["isDefault"];
            (<any>this).isEmpty = _data["isEmpty"];
        }
    }

    static fromJS(data: any): MessageSender {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sender"] = this.sender;
        data["displayName"] = this.displayName;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isDefault"] = this.isDefault;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}

export interface IMessageSender {
    id?: string;
    sender?: string | undefined;
    displayName?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date | undefined;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    isDefault?: boolean;
    isEmpty?: boolean;
}

export class MessageSenderResultSet implements IMessageSenderResultSet {
    count?: number;
    items?: MessageSender[] | undefined;

    constructor(data?: IMessageSenderResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MessageSender.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageSenderResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSenderResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageSenderResultSet {
    count?: number;
    items?: MessageSender[] | undefined;
}

export class MessageType implements IMessageType {
    id?: string;
    name?: string | undefined;

    constructor(data?: IMessageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MessageType {
        data = typeof data === 'object' ? data : {};
        let result = new MessageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMessageType {
    id?: string;
    name?: string | undefined;
}

export class MessageTypeResultSet implements IMessageTypeResultSet {
    count?: number;
    items?: MessageType[] | undefined;

    constructor(data?: IMessageTypeResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MessageType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageTypeResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTypeResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageTypeResultSet {
    count?: number;
    items?: MessageType[] | undefined;
}

export class Period implements IPeriod {
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Period {
        data = typeof data === 'object' ? data : {};
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPeriod {
    from?: Date | undefined;
    to?: Date | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Template implements ITemplate {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    content?: { [key: string]: MessageContent; } | undefined;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ITemplate {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
}

export class TemplateListItem implements ITemplateListItem {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    channels?: MessageChannelKind[];

    constructor(data?: ITemplateListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(item);
            }
        }
    }

    static fromJS(data: any): TemplateListItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item);
        }
        return data;
    }
}

export interface ITemplateListItem {
    id?: string;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    channels?: MessageChannelKind[];
}

export class TemplateListItemResultSet implements ITemplateListItemResultSet {
    count?: number;
    items?: TemplateListItem[] | undefined;

    constructor(data?: ITemplateListItemResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TemplateListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateListItemResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateListItemResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateListItemResultSet {
    count?: number;
    items?: TemplateListItem[] | undefined;
}

export class UpdateCampaignRequest implements IUpdateCampaignRequest {
    isGlobal?: boolean;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    activePeriod?: Period;
    typeId?: string | undefined;
    recipientListId?: string | undefined;
    data?: any | undefined;

    constructor(data?: IUpdateCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobal = _data["isGlobal"];
            this.title = _data["title"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
            this.actionLink = _data["actionLink"] ? Hyperlink.fromJS(_data["actionLink"]) : <any>undefined;
            this.activePeriod = _data["activePeriod"] ? Period.fromJS(_data["activePeriod"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.recipientListId = _data["recipientListId"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdateCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobal"] = this.isGlobal;
        data["title"] = this.title;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        data["actionLink"] = this.actionLink ? this.actionLink.toJSON() : <any>undefined;
        data["activePeriod"] = this.activePeriod ? this.activePeriod.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["recipientListId"] = this.recipientListId;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdateCampaignRequest {
    isGlobal?: boolean;
    title?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
    actionLink?: Hyperlink;
    activePeriod?: Period;
    typeId?: string | undefined;
    recipientListId?: string | undefined;
    data?: any | undefined;
}

export class UpdateContactRequest implements IUpdateContactRequest {
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    distributionListId?: string | undefined;

    constructor(data?: IUpdateContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.distributionListId = _data["distributionListId"];
        }
    }

    static fromJS(data: any): UpdateContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["distributionListId"] = this.distributionListId;
        return data;
    }
}

export interface IUpdateContactRequest {
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    distributionListId?: string | undefined;
}

export class UpdateDistributionListRequest implements IUpdateDistributionListRequest {
    name?: string | undefined;

    constructor(data?: IUpdateDistributionListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateDistributionListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDistributionListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateDistributionListRequest {
    name?: string | undefined;
}

export class UpdateMessageSenderRequest implements IUpdateMessageSenderRequest {
    sender?: string | undefined;
    displayName?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IUpdateMessageSenderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdateMessageSenderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageSenderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateMessageSenderRequest {
    sender?: string | undefined;
    displayName?: string | undefined;
    isDefault?: boolean;
}

export class UpdateMessageTypeRequest implements IUpdateMessageTypeRequest {
    name?: string | undefined;

    constructor(data?: IUpdateMessageTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateMessageTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateMessageTypeRequest {
    name?: string | undefined;
}

export class UpdateTemplateRequest implements IUpdateTemplateRequest {
    name?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;

    constructor(data?: IUpdateTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key] ? MessageContent.fromJS(_data["content"][key]) : new MessageContent();
                }
            }
        }
    }

    static fromJS(data: any): UpdateTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = this.content[key] ? this.content[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUpdateTemplateRequest {
    name?: string | undefined;
    content?: { [key: string]: MessageContent; } | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export enum MessageChannelKind {
    None = "None",
    Inbox = "Inbox",
    PushNotification = "PushNotification",
    Email = "Email",
    SMS = "SMS",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}